import { useTranslation } from "react-i18next";

import { Table, Text } from "@pentabd/ui";

import { SelectProductsTableColumn } from "./SelectProductsTableColumn";

import { useProductsList } from "@hooks/procurements/demand/useProductList";

import { TablePagination } from "@helpers/tablePagination";

import { PaginationType } from "@type/HRM/pagination";

type Props = {
  selectProductHandler: (data: any) => void;
  selectedProduct: any;
};

function SelectProductTable({ selectProductHandler, selectedProduct }: Props) {
  const { t } = useTranslation();

  const {
    products: { getData },
    handleQuery,
  } = useProductsList();
  const { data, pagination } = getData || {};

  return (
    <div className="mt-10">
      <div className="border-bottom my-9 pb-6">
        <Text color="subtitle1" component="h4" weight="semibold">
          {t("PROCUREMENT_DEMAND.DEMAND_CREATE.SELECT_PRODUCT_TABLE.HEADING")}
        </Text>
      </div>
      <Table
        columns={
          SelectProductsTableColumn(
            t,
            selectProductHandler,
            selectedProduct,
          ) as any
        }
        rows={data || []}
        pagination={TablePagination(pagination as PaginationType, handleQuery)}
      />
    </div>
  );
}

export default SelectProductTable;
